export default "__VITE_ASSET__jH$Djqk2__"